import { render } from "./SeoDescriptionCell.vue?vue&type=template&id=0bf873c4&scoped=true"
import script from "./SeoDescriptionCell.vue?vue&type=script&lang=js"
export * from "./SeoDescriptionCell.vue?vue&type=script&lang=js"

import "./SeoDescriptionCell.vue?vue&type=style&index=0&id=0bf873c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf873c4"]])

export default __exports__